import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import api from "../services/api";
import './RunNewPage.css';






//const RunNewPay = () => {
  const RunNewPay = ({ embedded = false, onDone, selectedBusiness }) => {
  const { id: businessId } = useParams();
    const navigate = useNavigate();
    const location = useLocation();
const appliedSubwayPrefillRef = useRef(null);
const [subwayPrefillMessage, setSubwayPrefillMessage] = useState("");
    const [hourlyEmployees, setHourlyEmployees] = useState([]);
    const [salariedEmployees, setSalariedEmployees] = useState([]);
    const [payPeriod, setPayPeriod] = useState(null);
    const [employeeInputs, setEmployeeInputs] = useState({});
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [expandedRows, setExpandedRows] = useState({});
    const [leaveRequests, setLeaveRequests] = useState([]);
    const [leaveRequestInputs, setLeaveRequestInputs] = useState({});
    const [hourlyVacationHours, setHourlyVacationHours] = useState({});
    const [salariedVacationHours, setSalariedVacationHours] = useState({});
    const [taxStatus, setTaxStatus] = useState({ noIssues: true, missingFields: {} }); // For tax status
    const [excludedEmployees, setExcludedEmployees] = useState(new Set());
    const [isSubwayBusiness, setIsSubwayBusiness] = useState(false);
    const [submitting, setSubmitting] = useState(false);

    const [showFundingWarning, setShowFundingWarning] = useState(false);

    const [allExpanded, setAllExpanded] = useState(false);
    



    // which employees already have a payroll_inputs record for this period
const [hasRecordByEmp, setHasRecordByEmp] = useState({});
// per-employee edit toggle
const [editing, setEditing] = useState({});
const toggleEdit = (id) => setEditing(prev => ({ ...prev, [id]: !prev[id] }));
const fmt = (v) => (v === 0 ? "0" : v == null ? "—" : String(v));


const gt0 = (v) => v != null && Number(v) > 0;
const chipClass = (v) => `chip${gt0(v) ? " chip--active" : ""}`;




    const handleCheckboxChange = (employeeId) => {
        setExcludedEmployees((prev) => {
            const newSet = new Set(prev);
            if (newSet.has(employeeId)) {
                newSet.delete(employeeId);
            } else {
                newSet.add(employeeId);
            }
            return newSet;
        });
    };
    



    const toggleInputs = (employeeId) => {
        setExpandedRows((prev) => ({
            ...prev,
            [employeeId]: !prev[employeeId]
        }));
    };

    const frequencyMultiplier = {
        weekly: 52,
        biweekly: 26,
        semimonthly: 24,
        monthly: 12,
    };

    const getPayPeriodSalary = (annualSalary) => {
        if (!payPeriod || !payPeriod.frequency) return annualSalary;
        const multiplier = frequencyMultiplier[payPeriod.frequency.toLowerCase()] || 1;
        const frequencySalary = (annualSalary / multiplier).toFixed(2);
        return frequencySalary;
    };

    const formatDate = (date) => new Date(date).toISOString().split("T")[0];


   useEffect(() => {
  const handleWheel = (e) => {
    if (document.activeElement?.type === "number") {
      e.preventDefault();
    }
  };

  document.addEventListener("wheel", handleWheel, { passive: false });

  return () => {
    document.removeEventListener("wheel", handleWheel);
  };
}, []);


const applyOwnerPrefill = (
  prefill,
  hourly,
  salaried,
  leaveRequests,
  setEmployeeInputs,
  setExcludedEmployees,
  setLeaveRequestInputs,
  setHourlyVacationHours,
  setSalariedVacationHours
) => {
  // mark which employees already have saved records
  const hasMap = {};
  Object.keys(prefill?.inputsByEmployee || {}).forEach((empId) => {
    hasMap[Number(empId)] = true;
  });
  setHasRecordByEmp(hasMap);

  // mark excluded
  const excluded = new Set();
  Object.entries(prefill?.inputsByEmployee || {}).forEach(([empId, v]) => {
    if (v?.is_excluded) excluded.add(Number(empId));
  });

  // merge field values
  const merged = {};
  [...hourly, ...salaried].forEach((emp) => {
    const v = prefill?.inputsByEmployee?.[emp.id] || {};
    merged[emp.id] = {
      regularHours: v.regularHours ?? null,
      overtimeHours: v.overtimeHours ?? null,
      doubletimeHours: v.doubletimeHours ?? null,
      cashAdvance: v.cashAdvance ?? null,
      bonus: v.bonus ?? null,
      tips: v.tips ?? null,
      reimbursement: v.reimbursement ?? null,
      other: v.other ?? null,
      vacationHours: v.vacationHours ?? null,
      vacationPay: v.vacationPay ?? null,
    };
  });

  // map payroll_inputs_id by employee
  const piByEmp = {};
  Object.entries(prefill?.inputsByEmployee || {}).forEach(([empId, v]) => {
    if (v?.payroll_inputs_id) piByEmp[Number(empId)] = v.payroll_inputs_id;
  });

  // per-leave hrs input
  const newLeaveInputs = {};
  leaveRequests.forEach((lr) => {
    const pid = piByEmp[lr.employee_id];
    if (!pid) return;
    const arr = prefill?.leaveHoursByInputId?.[pid] || [];
    const match = arr.find((x) => x.leave_request_id === lr.id);
    if (match) newLeaveInputs[lr.id] = Number(match.hours_this_payroll || 0);
  });

  // rollups
  const hvh = {},
    svh = {};
  [...hourly, ...salaried].forEach((emp) => {
    const sum = leaveRequests
      .filter((l) => l.employee_id === emp.id)
      .reduce((acc, l) => acc + (newLeaveInputs[l.id] ?? 0), 0);
    if (emp.type === "hourly") hvh[emp.id] = sum;
    else svh[emp.id] = sum;
  });

  setExcludedEmployees(excluded);
  setEmployeeInputs((prev) => {
  const next = { ...prev };

  [...hourly, ...salaried].forEach((emp) => {
    const v = prefill?.inputsByEmployee?.[emp.id] || {};

    next[emp.id] = {
      ...next[emp.id],
      ...(v.regularHours != null ? { regularHours: v.regularHours } : {}),
      ...(v.overtimeHours != null ? { overtimeHours: v.overtimeHours } : {}),
      ...(v.doubletimeHours != null ? { doubletimeHours: v.doubletimeHours } : {}),
      ...(v.cashAdvance != null ? { cashAdvance: v.cashAdvance } : {}),
      ...(v.bonus != null ? { bonus: v.bonus } : {}),
      ...(v.tips != null ? { tips: v.tips } : {}),
      ...(v.reimbursement != null ? { reimbursement: v.reimbursement } : {}),
      ...(v.other != null ? { other: v.other } : {}),
      ...(v.vacationHours != null ? { vacationHours: v.vacationHours } : {}),
      ...(v.vacationPay != null ? { vacationPay: v.vacationPay } : {}),
    };
  });

  return next;
});
  setLeaveRequestInputs(newLeaveInputs);
  setHourlyVacationHours(hvh);
  setSalariedVacationHours(svh);
};




    useEffect(() => {
        const fetchData = async () => {
            try {
                const payPeriodResponse = await api.get(`/payroll/next/${businessId}`);
                setPayPeriod(payPeriodResponse.data);

                const hourlyResponse = await api.get(`/businesses/${businessId}/employees/hourly`);
                const hourly = hourlyResponse.data.map((employee) => ({
                    ...employee,
                    type: "hourly",
                }));
                setHourlyEmployees(hourly);

                const salariedResponse = await api.get(`/businesses/${businessId}/employees/salary`);
                const salaried = salariedResponse.data.map((employee) => ({
                    ...employee,
                    type: "salaried",
                }));
                setSalariedEmployees(salaried);

                const subwayStatusResponse = await api.get(`/businesses/${businessId}/subway-status`);
                setIsSubwayBusiness(Boolean(subwayStatusResponse.data?.is_subway));

                const leaveResponse = await api.get(
                    `/leave-requests/${businessId}/${formatDate(payPeriodResponse.data.start_date)}/${formatDate(payPeriodResponse.data.end_date)}`
                );
                setLeaveRequests(leaveResponse.data);
                console.log(leaveResponse.data);
                // 🔽 NEW: owner prefill from payroll_inputs





                // Fetch tax status
                const { data: taxStatusData } = await api.get(`/tax-status-fetch/${businessId}`);
                setTaxStatus(taxStatusData);

                try {
                    const fundingResponse = await api.get(`/billing/funding-check/${businessId}`);
                    setShowFundingWarning(fundingResponse.data.showFundingWarning);
                    } catch (err) {
                    console.error("❌ Funding check failed:", err);
                    // Optional: decide to show the warning by default if the API fails
                    setShowFundingWarning(true); 
                    }






                const initialInputs = {};
                [...hourly, ...salaried].forEach((employee) => {
                    initialInputs[employee.id] = {
                        regularHours: null,
                        overtimeHours: null,
                        doubletimeHours: null,
                        cashAdvance: null,
                        bonus: null,
                        tips: null,
                        reimbursement: null,
                        other: null,
                        vacationHours: employee.type === "hourly" ? null : undefined,
                        vacationPay: employee.type === "salaried" ? null : undefined,
                    };
                });
               setEmployeeInputs((prev) => {
  const next = { ...prev };

  [...hourly, ...salaried].forEach((employee) => {
    next[employee.id] = {
      regularHours: null,
      overtimeHours: null,
      doubletimeHours: null,
      cashAdvance: null,
      bonus: null,
      tips: null,
      reimbursement: null,
      other: null,
      vacationHours: employee.type === "hourly" ? null : undefined,
      vacationPay: employee.type === "salaried" ? null : undefined,
      ...next[employee.id],
    };
  });

  return next;
});

                try {
  const start = formatDate(payPeriodResponse.data.start_date);
  const end   = formatDate(payPeriodResponse.data.end_date);

  const { data: prefill } = await api.get('/owner/payroll-inputs', {
    params: { business_id: businessId, start_date: start, end_date: end },
  });

  applyOwnerPrefill(
    prefill || {},
    hourly, salaried,
    leaveResponse.data,
    setEmployeeInputs,
    setExcludedEmployees,
    setLeaveRequestInputs,
    setHourlyVacationHours,
    setSalariedVacationHours
  );
} catch (e) {
  // no prefill = fine; keep your initialInputs
  console.log("No owner prefill for this period (ok).");
}

                setError(null);
            } catch (err) {
                console.error("Error fetching employees:", err);
                setError("Failed to fetch employees. Please try again.");
            } finally {
                setLoading(false);
            }
        };


        fetchData();
    }, [businessId]);



    
    const allEmployees = [...hourlyEmployees, ...salariedEmployees];

const expandAll = () => {
  const map = {};
  allEmployees.forEach(e => { map[e.id] = true; });
  setExpandedRows(map);
  setAllExpanded(true);
};

const collapseAll = () => {
  setExpandedRows({});
  setAllExpanded(false);
};

// keep “expand all” sticky if employees list changes after load
useEffect(() => {
  if (!allExpanded) return;
  const map = {};
  allEmployees.forEach(e => { map[e.id] = true; });
  setExpandedRows(map);
  // eslint-disable-next-line react-hooks/exhaustive-deps
}, [hourlyEmployees, salariedEmployees]);

    
   


    const handleLeaveInputChange = (leaveId, employeeId, value) => {
        setLeaveRequestInputs((prevInputs) => {
            const newInputs = {
                ...prevInputs,
                [leaveId]: value ? parseFloat(value) : 0, // ✅ Update only this leave request input
            };
    
            // ✅ Calculate total vacation hours only for this employee
            const totalVacationHours = leaveRequests
                .filter((leave) => leave.employee_id === employeeId) // ✅ Only sum this employee’s leave requests
                .reduce((sum, leave) => sum + (newInputs[leave.id] ?? 0), 0);
    
            // ✅ Find the employee type (hourly or salaried)
            const employee = [...hourlyEmployees, ...salariedEmployees].find(emp => emp.id === employeeId);
    
            if (employee) {
                if (employee.type === "hourly") {
                    setHourlyVacationHours((prev) => ({
                        ...prev,
                        [employeeId]: totalVacationHours, // ✅ Updates only this employee's vacation hours
                    }));
                    handleInputChange(employeeId, "vacationHours", totalVacationHours);
                } else {
                    setSalariedVacationHours((prev) => ({
                        ...prev,
                        [employeeId]: totalVacationHours, // ✅ Updates only this employee's vacation pay
                    }));
                    handleInputChange(employeeId, "vacationPay", totalVacationHours);
                }
            }
    
            return newInputs; // ✅ Ensures only the changed input updates
        });
    };
    
    
    
    
    
useEffect(() => {
  const subwayState = location.state;

  if (!subwayState?.subwayFinalize) return;
  if (!Array.isArray(subwayState.subwayPrefill) || !subwayState.subwayPrefill.length) return;
  if (!hourlyEmployees.length && !salariedEmployees.length) return;

  if (appliedSubwayPrefillRef.current === subwayState.subwayPrefillToken) {
    return;
  }

  const prefillMap = {};
  subwayState.subwayPrefill.forEach((item) => {
    const employeeId = Number(item.employee_id);
    if (employeeId) {
      prefillMap[employeeId] = item;
    }
  });

  setEmployeeInputs((prev) => {
    const updated = { ...prev };

    [...hourlyEmployees, ...salariedEmployees].forEach((employee) => {
      const match = prefillMap[employee.id];
      if (!match) return;

      updated[employee.id] = {
        ...updated[employee.id],
        ...(employee.type === "hourly"
          ? {
              regularHours: Number(match.regular_hours || 0),
              overtimeHours: Number(match.overtime_hours || 0),
            }
          : {}),
        tips: Number(match.total_tips || 0),
      };
    });

    return updated;
  });

  appliedSubwayPrefillRef.current = subwayState.subwayPrefillToken;

  setSubwayPrefillMessage(
    `Subway payroll finalized for ${subwayState.subwayStartDate} to ${subwayState.subwayEndDate}. Matching hours and tips were auto-filled.`
  );

  navigate(location.pathname, {
    replace: true,
    state: null,
  });
}, [
  location,
  navigate,
  hourlyEmployees,
  salariedEmployees,
]);



    const handleInputChange = (employeeId, field, value) => {
        setEmployeeInputs((prev) => ({
            ...prev,
            [employeeId]: {
                ...prev[employeeId],
                [field]: value ? parseFloat(value) : null,
            },
        }));
    };


    const handleSubwayPayroll = () => {
  if (!payPeriod) return;

  navigate(`/dashboard/business/${businessId}/payroll-sync`, {
    state: {
      startDate: formatDate(payPeriod.start_date),
      endDate: formatDate(payPeriod.end_date),
    },
  });
};

    const handleSubmit = async () => {
      if (submitting) return; 
        
        //const collectedResults = [...hourlyEmployees, ...salariedEmployees].map((employee) => {
        
        const collectedResults = [...hourlyEmployees, ...salariedEmployees]
            .filter((employee) => !excludedEmployees.has(employee.id)) // Exclude checked employees
            .map((employee) => {
            const perhourSalary = employee.salary_amt / 52 / 40 || null;

            


            const commonFields = {
                id: employee.id,
                business_id: businessId,
                business_state: payPeriod.business_state,
                start_date: payPeriod.start_date,
                end_date: payPeriod.end_date,
                pay_date: payPeriod.pay_date,
                frequency: payPeriod.frequency,
                name: `${employee.first_name} ${employee.last_name}`,
                perhour_salary: perhourSalary,
                ...employeeInputs[employee.id],
            };

            if (employee.type === "hourly") {
                return {
                    ...commonFields,
                    hourly_rate: employee.hourly_amt,
                    vacation_hours: employeeInputs[employee.id]?.vacationHours ?? 0,
                };
            } else {
                return {
                    ...commonFields,
                    salary_amt: Number(getPayPeriodSalary(employee.salary_amt)),
                    vacation_pay: employeeInputs[employee.id]?.vacationPay !== undefined 
                    ? employeeInputs[employee.id].vacationPay 
                    : 0,

                };
            }
        });


        // ✅ Collect Leave Request Updates Separately
                const leaveRequestUpdates = leaveRequests.map((leave) => ({
                    leave_id: leave.id,
                    employee_id: leave.employee_id,
                    business_id: businessId,
                    total_hours_paid: leave.total_hours_paid ?? 0,
                    current_hours_paid: leaveRequestInputs[leave.id] ?? 0, // Default to 0 if not set
                    total_hours_requested: leave.total_hours_requested,
                    total_days_requested: leave.total_days_requested,
                    total_days_paid: leave.total_days_paid ?? 0,
                    leave_days_in_period: leave.leave_days_in_period,
                    start_date: payPeriod.start_date,
                    end_date: payPeriod.end_date,
                    pay_date: payPeriod.pay_date,
                }));

    
        setSubmitting(true);
        try {
            //const response = await api.post(`/payroll/calculate`, collectedResults);
            const response = await api.post(`/payroll/calculate`, {
                payrollData: collectedResults,
                leaveRequestUpdates // ✅ Send leave requests separately
            });
            const { success, errors } = response.data;


            if (errors && errors.length > 0) {  
                alert(
                    `Partial success:\n\nSuccess:\n${success
                        .map((item) => ` - ${item.name}`)
                        .join("\n")}\n\nErrors:\n${errors.join("\n")}`
                );
            } else {
                console.log("All payroll records processed successfully.");
                if (embedded && typeof onDone === "function") {
     onDone();                // 🔔 let the parent refresh + switch to "Overview"
   } else {
     navigate(`/dashboard/business/${businessId}/viewpayroll`);
   }
            }
        } catch (error) {
            console.error("Error submitting payroll data:", error);
            alert("Failed to submit payroll data. Please try again.");
        } finally {
    setSubmitting(false);
  }
    };

    if (loading) {
        return <p>Loading employees...</p>;
    }

    if (error) {
        return <p>{error}</p>;
    }

    return (
        <div className="run-new-main">
        
            

            {taxStatus.noIssues ? (
                <p></p>
                
            ) : (
                <>
                <p className="issues-text">There are missing tax fields. Please fill tax information.</p>
                <button className="tax-button" onClick={() => navigate(`/dashboard/business/${businessId}/detect`)}>
            Tax Information
        </button>
        </>
            )}

            {payPeriod && (
                <div className="pay-period-payroll-cont">
                <div className="ppl-pay">
                    <label className="pay-period-label">Pay Period:</label>{" "}
                    <span className="pay-period-content">
                    {new Date(payPeriod.start_date).toLocaleDateString()} - {" "}
                    {new Date(payPeriod.end_date).toLocaleDateString()} <br></br>
                    </span>
                    </div>

                <div className="ppl-pay">
                    <label className="pay-period-label">Pay Date:</label>{" "}
                    <span className="pay-period-content">
                    {new Date(payPeriod.pay_date).toLocaleDateString()} 
                    </span>
                    </div>
                     {isSubwayBusiness && (
  <button className="run-new-submit" type="button" onClick={handleSubwayPayroll}>
    Subway Payroll
  </button>
)}
<div style={{display:'flex', justifyContent:'flex-end', margin:'8px 0'}}>
  <button
    className="expand-all-btn"
    onClick={allExpanded ? collapseAll : expandAll}
  >
    {allExpanded ? 'Collapse all' : 'Expand all'}
  </button>
</div>
                </div>
            )}
            {subwayPrefillMessage ? (
  <div className="subway-prefill-message">
    {subwayPrefillMessage}
  </div>
) : null}
            

            
  



            <div className="run-new-employee-list">
  {[...hourlyEmployees, ...salariedEmployees].map((employee) => {
    const employeeLeaveRequests = leaveRequests.filter((leave) => leave.employee_id === employee.id);
    const hasLeaveRequests = employeeLeaveRequests.length > 0;

    return (
      <div key={employee.id} className={`run-new-employee-block ${hasLeaveRequests ? "employee-leave-highlight" : ""}`}>

        {/* Optional: Leave Summary & Requests */}
        {hasLeaveRequests && (
          <>
            <div className="vacation-summary">
              <div className="summary-div">Vacation Summary:</div>{" "}
              {employee.total_vacation_hours_earned ? (
                <>
                  Earned: <div>{employee.total_vacation_hours_earned ?? 0} hrs</div> |{" "}
                  Used: <div>{employee.total_vacation_hours_used ?? 0} hrs</div> |{" "}
                  Available: <div>{employee.available_vacation_hours ?? 0} hrs</div>
                </>
              ) : "No vacation hours logged yet."}
            </div>

            <div className="leave-requests-section">
              <h4>Leave Request:</h4>
              <div className="leave-request-header">
                <span className="span-type">Type</span>
                <span className="date-span">Dates</span>
                <span className="days-req">Total Days</span>
                <span className="hours-req">Hours Req</span>
                <span className="hours-paid">Hours Paid</span>
                <span className="days-paid">Days Paid</span>
                <span className="hours-left">Hours Left</span>
                <span className="days-left">Days Left</span>
                <span className="period-days">Days in Period</span>
                <span className="this-span">Hrs This Payroll</span>
              </div>
              {employeeLeaveRequests.map((leave) => {
                const totalHoursRequested = Number(leave.total_hours_requested) || 0;
                const totalHoursPaid = Number(leave.total_hours_paid) || 0;
                const totalDaysRequested = Number(leave.total_days_requested) || 0;
                const totalDaysPaid = Number(leave.total_days_paid) || 0;
                const leaveDaysInPeriod = Number(leave.leave_days_in_period) || 0;

                return (
                  <div key={leave.id} className="leave-request-row">
                    <span className="span-type">{leave.request_type}</span>
                    <div className="date-span">{new Date(leave.start_date).toLocaleDateString()} - {new Date(leave.end_date).toLocaleDateString()}</div>
                    <span className="days-req">{totalDaysRequested}</span>
                    <span className="hours-req">{totalHoursRequested}</span>
                    <span className="hours-paid">{totalHoursPaid}</span>
                    <span className="days-paid">{totalDaysPaid}</span>
                    <span className="hours-left">{totalHoursRequested - totalHoursPaid}</span>
                    <span className="days-left">{totalDaysRequested - totalDaysPaid}</span>
                    <span className="period-days">{leaveDaysInPeriod}</span>
                    <input
                      type="number"
                      placeholder="Vac. Hours"
                      value={leaveRequestInputs[leave.id] ?? ""}
                      onChange={(e) => handleLeaveInputChange(leave.id, leave.employee_id, e.target.value)}
                    />
                  
                  </div>
                );
              })}
            </div>
          </>
        )}

        {/* Row 1: Basic Info */}
        <div className="employee-info-row">
        <div className="skip-it">
        <label className="skip-label"> Skip </label>
          <input
            type="checkbox"
            className="run-new-checkbox"
            checked={excludedEmployees.has(employee.id)}
            onChange={() => handleCheckboxChange(employee.id)}
          />
          </div>
          <span className="run-new-name">{employee.first_name} {employee.last_name}</span>
          <span className="run-new-type">{employee.type === "hourly" ? "Hourly" : "Salary"}</span>
          <span className="run-new-pay">
            {employee.type === "hourly"
              ? `$${employee.hourly_amt} /hr`
              : `$${getPayPeriodSalary(employee.salary_amt)} /period`}
          </span>
          {/* show edit only if a record exists for this employee */}
{hasRecordByEmp[employee.id] && (
  <button
    className="toggle-arrow"
    title={editing[employee.id] ? "Close edit" : "Edit"}
    onClick={() => toggleEdit(employee.id)}
    style={{ cursor: "pointer", background: "none", border: "none" }}
  >
    {editing[employee.id] ? "▲" : "✏️"}
  </button>
)}

          <span className="toggle-arrow" onClick={() => toggleInputs(employee.id)}>
            {expandedRows[employee.id] ? "▲" : "▼"}
          </span>
        </div>

        {/* Row 2: Visible Inputs */}
        <div className="employee-inputs-row">
  {(!hasRecordByEmp[employee.id] || editing[employee.id]) ? (
    employee.type === "hourly" ? (
      <>
        <input
          type="number" placeholder="Reg. Hours"
          value={employeeInputs[employee.id]?.regularHours ?? ""}
          onChange={(e) => handleInputChange(employee.id, "regularHours", e.target.value)}
        />
        <input
          type="number" placeholder="OT Hours"
          value={employeeInputs[employee.id]?.overtimeHours ?? ""}
          onChange={(e) => handleInputChange(employee.id, "overtimeHours", e.target.value)}
        />
        <input
          type="number" placeholder="DT Hours"
          value={employeeInputs[employee.id]?.doubletimeHours ?? ""}
          onChange={(e) => handleInputChange(employee.id, "doubletimeHours", e.target.value)}
        />
        <input
          type="number" placeholder="Vac. Hours"
          value={
            hourlyVacationHours[employee.id] ??
            employeeInputs[employee.id]?.vacationHours ?? ""
          }
          onChange={(e) => {
            const value = e.target.value;
            setHourlyVacationHours((prev) => ({
              ...prev,
              [employee.id]: value ? parseFloat(value) : "",
            }));
            handleInputChange(employee.id, "vacationHours", value);
          }}
        />
      </>
    ) : (
      <input
        type="number" placeholder="Vac. Hours"
        value={
          salariedVacationHours[employee.id] ??
          employeeInputs[employee.id]?.vacationPay ?? ""
        }
        onChange={(e) => {
          const value = e.target.value;
          setSalariedVacationHours((prev) => ({
            ...prev,
            [employee.id]: value ? parseFloat(value) : "",
          }));
          handleInputChange(employee.id, "vacationPay", value);
        }}
      />
    )
  ) : (
    // read-only chips
    employee.type === "hourly" ? (
      <>
        <span className={chipClass(employeeInputs[employee.id]?.regularHours)}>Regular Hours: {fmt(employeeInputs[employee.id]?.regularHours)}</span>
        <span className={chipClass(employeeInputs[employee.id]?.overtimeHours)}>Overtime Hours: {fmt(employeeInputs[employee.id]?.overtimeHours)}</span>
        <span className={chipClass(employeeInputs[employee.id]?.doubletimeHours)}>Doubletime Hours: {fmt(employeeInputs[employee.id]?.doubletimeHours)}</span>
        <span className={chipClass(employeeInputs[employee.id]?.vacationHours)}>Vacation Hours: {fmt(employeeInputs[employee.id]?.vacationHours)}</span>
      </>
    ) : (
      <span className={chipClass(employeeInputs[employee.id]?.vacationPay)}>Vacation Hours: {fmt(employeeInputs[employee.id]?.vacationPay)}</span>
    )
  )}
</div>


        {/* Row 3: Expanded Inputs */}
        {expandedRows[employee.id] && (
            <>
            
          <div className="employee-extra-inputs">
  {(!hasRecordByEmp[employee.id] || editing[employee.id]) ? (
    <>
      <input
        type="number" placeholder="Cash Advance"
        value={employeeInputs[employee.id]?.cashAdvance ?? ""}
        onChange={(e) => handleInputChange(employee.id, "cashAdvance", e.target.value)}
      />
      <input
        type="number" placeholder="Bonus"
        value={employeeInputs[employee.id]?.bonus ?? ""}
        onChange={(e) => handleInputChange(employee.id, "bonus", e.target.value)}
      />
      <input
        type="number" placeholder="Tips"
        value={employeeInputs[employee.id]?.tips ?? ""}
        onChange={(e) => handleInputChange(employee.id, "tips", e.target.value)}
      />
      <input
        type="number" placeholder="Reimbursement"
        value={employeeInputs[employee.id]?.reimbursement ?? ""}
        onChange={(e) => handleInputChange(employee.id, "reimbursement", e.target.value)}
      />
      
    </>
  ) : (
    <>
      <span className={chipClass(employeeInputs[employee.id]?.cashAdvance)}>Cash Advance: {fmt(employeeInputs[employee.id]?.cashAdvance)}</span>
      <span className={chipClass(employeeInputs[employee.id]?.bonus)}>Bonus: {fmt(employeeInputs[employee.id]?.bonus)}</span>
      <span className={chipClass(employeeInputs[employee.id]?.tips)}>Tips: {fmt(employeeInputs[employee.id]?.tips)}</span>
      <span className={chipClass(employeeInputs[employee.id]?.reimbursement)}>Reimbursement: {fmt(employeeInputs[employee.id]?.reimbursement)}</span>
    </>
  )}
</div>
<div className="vacation-summary-expanded">
    <div className="summary-div">Vacation Summary:</div>{" "}
    {employee.total_vacation_hours_earned ? (
      <>
        Earned: <div>{employee.total_vacation_hours_earned ?? 0} hrs</div> |{" "}
        Used: <div>{employee.total_vacation_hours_used ?? 0} hrs</div> |{" "}
        Available: <div>{employee.available_vacation_hours ?? 0} hrs</div>
      </>
    ) : (
      "No vacation hours logged yet."
    )}
  </div>

<span 
    className="ca-balance"
    title={`Paid Out: $${(employee.cash_advance_paid_out_total ?? 0)} | Recouped: $${(employee.cash_advance_recouped_total ?? 0)}`}
    style={{
      background: (employee.cash_advance_balance ?? 0) > 0 ? '#dc3545' : '#00c364',
      color: (employee.cash_advance_balance ?? 0) > 0 ? 'white' : 'white',
    }}
  >
    Cash Advance Balance: ${Number(employee.cash_advance_balance ?? 0)}
  </span>
          </>
        )}
      </div>
    );
  })}
</div>



            




            

            
            {taxStatus.noIssues && !showFundingWarning && (
            <button className="run-new-submit" onClick={handleSubmit} disabled={submitting}>
                {submitting ? "Submitting..." : "Submit"}
            </button>
            )}
            {showFundingWarning && (
            <div className="issues-text">
                No funding account is set up for this business. Please add one to continue.
            </div>
            )}





            {/* <button className="run-new-submit" onClick={handleSubmit}>Submit</button> */}
            
        </div>
    );
};

export default RunNewPay;







// import React, { useEffect, useState } from "react";
// import { useNavigate, useParams } from "react-router-dom";
// import api from "../services/api";
// import './RunNewPage.css';

// //const RunNewPay = () => {
//   const RunNewPay = ({ embedded = false, onDone }) => {
//   const { id: businessId } = useParams();
//     const navigate = useNavigate();
//     const [hourlyEmployees, setHourlyEmployees] = useState([]);
//     const [salariedEmployees, setSalariedEmployees] = useState([]);
//     const [payPeriod, setPayPeriod] = useState(null);
//     const [employeeInputs, setEmployeeInputs] = useState({});
//     const [loading, setLoading] = useState(true);
//     const [error, setError] = useState(null);
//     const [expandedRows, setExpandedRows] = useState({});
//     const [leaveRequests, setLeaveRequests] = useState([]);
//     const [leaveRequestInputs, setLeaveRequestInputs] = useState({});
//     const [hourlyVacationHours, setHourlyVacationHours] = useState({});
//     const [salariedVacationHours, setSalariedVacationHours] = useState({});
//     const [taxStatus, setTaxStatus] = useState({ noIssues: true, missingFields: {} }); // For tax status
//     const [excludedEmployees, setExcludedEmployees] = useState(new Set());

//     const [showFundingWarning, setShowFundingWarning] = useState(false);

//     const [allExpanded, setAllExpanded] = useState(false);



//     // which employees already have a payroll_inputs record for this period
// const [hasRecordByEmp, setHasRecordByEmp] = useState({});
// // per-employee edit toggle
// const [editing, setEditing] = useState({});
// const toggleEdit = (id) => setEditing(prev => ({ ...prev, [id]: !prev[id] }));
// const fmt = (v) => (v === 0 ? "0" : v == null ? "—" : String(v));


// const gt0 = (v) => v != null && Number(v) > 0;
// const chipClass = (v) => `chip${gt0(v) ? " chip--active" : ""}`;




//     const handleCheckboxChange = (employeeId) => {
//         setExcludedEmployees((prev) => {
//             const newSet = new Set(prev);
//             if (newSet.has(employeeId)) {
//                 newSet.delete(employeeId);
//             } else {
//                 newSet.add(employeeId);
//             }
//             return newSet;
//         });
//     };
    



//     const toggleInputs = (employeeId) => {
//         setExpandedRows((prev) => ({
//             ...prev,
//             [employeeId]: !prev[employeeId]
//         }));
//     };

//     const frequencyMultiplier = {
//         weekly: 52,
//         biweekly: 26,
//         semimonthly: 24,
//         monthly: 12,
//     };

//     const getPayPeriodSalary = (annualSalary) => {
//         if (!payPeriod || !payPeriod.frequency) return annualSalary;
//         const multiplier = frequencyMultiplier[payPeriod.frequency.toLowerCase()] || 1;
//         const frequencySalary = (annualSalary / multiplier).toFixed(2);
//         return frequencySalary;
//     };

//     const formatDate = (date) => new Date(date).toISOString().split("T")[0];


   


// const applyOwnerPrefill = (
//   prefill,
//   hourly,
//   salaried,
//   leaveRequests,
//   setEmployeeInputs,
//   setExcludedEmployees,
//   setLeaveRequestInputs,
//   setHourlyVacationHours,
//   setSalariedVacationHours
// ) => {
//   // mark which employees already have saved records
//   const hasMap = {};
//   Object.keys(prefill?.inputsByEmployee || {}).forEach((empId) => {
//     hasMap[Number(empId)] = true;
//   });
//   setHasRecordByEmp(hasMap);

//   // mark excluded
//   const excluded = new Set();
//   Object.entries(prefill?.inputsByEmployee || {}).forEach(([empId, v]) => {
//     if (v?.is_excluded) excluded.add(Number(empId));
//   });

//   // merge field values
//   const merged = {};
//   [...hourly, ...salaried].forEach((emp) => {
//     const v = prefill?.inputsByEmployee?.[emp.id] || {};
//     merged[emp.id] = {
//       regularHours: v.regularHours ?? null,
//       overtimeHours: v.overtimeHours ?? null,
//       doubletimeHours: v.doubletimeHours ?? null,
//       cashAdvance: v.cashAdvance ?? null,
//       bonus: v.bonus ?? null,
//       tips: v.tips ?? null,
//       reimbursement: v.reimbursement ?? null,
//       other: v.other ?? null,
//       vacationHours: v.vacationHours ?? null,
//       vacationPay: v.vacationPay ?? null,
//     };
//   });

//   // map payroll_inputs_id by employee
//   const piByEmp = {};
//   Object.entries(prefill?.inputsByEmployee || {}).forEach(([empId, v]) => {
//     if (v?.payroll_inputs_id) piByEmp[Number(empId)] = v.payroll_inputs_id;
//   });

//   // per-leave hrs input
//   const newLeaveInputs = {};
//   leaveRequests.forEach((lr) => {
//     const pid = piByEmp[lr.employee_id];
//     if (!pid) return;
//     const arr = prefill?.leaveHoursByInputId?.[pid] || [];
//     const match = arr.find((x) => x.leave_request_id === lr.id);
//     if (match) newLeaveInputs[lr.id] = Number(match.hours_this_payroll || 0);
//   });

//   // rollups
//   const hvh = {},
//     svh = {};
//   [...hourly, ...salaried].forEach((emp) => {
//     const sum = leaveRequests
//       .filter((l) => l.employee_id === emp.id)
//       .reduce((acc, l) => acc + (newLeaveInputs[l.id] ?? 0), 0);
//     if (emp.type === "hourly") hvh[emp.id] = sum;
//     else svh[emp.id] = sum;
//   });

//   setExcludedEmployees(excluded);
//   setEmployeeInputs(merged);
//   setLeaveRequestInputs(newLeaveInputs);
//   setHourlyVacationHours(hvh);
//   setSalariedVacationHours(svh);
// };




//     useEffect(() => {
//         const fetchData = async () => {
//             try {
//                 const payPeriodResponse = await api.get(`/payroll/next/${businessId}`);
//                 setPayPeriod(payPeriodResponse.data);

//                 const hourlyResponse = await api.get(`/businesses/${businessId}/employees/hourly`);
//                 const hourly = hourlyResponse.data.map((employee) => ({
//                     ...employee,
//                     type: "hourly",
//                 }));
//                 setHourlyEmployees(hourly);

//                 const salariedResponse = await api.get(`/businesses/${businessId}/employees/salary`);
//                 const salaried = salariedResponse.data.map((employee) => ({
//                     ...employee,
//                     type: "salaried",
//                 }));
//                 setSalariedEmployees(salaried);

//                 const leaveResponse = await api.get(
//                     `/leave-requests/${businessId}/${formatDate(payPeriodResponse.data.start_date)}/${formatDate(payPeriodResponse.data.end_date)}`
//                 );
//                 setLeaveRequests(leaveResponse.data);
//                 console.log(leaveResponse.data);
//                 // 🔽 NEW: owner prefill from payroll_inputs





//                 // Fetch tax status
//                 const { data: taxStatusData } = await api.get(`/tax-status-fetch/${businessId}`);
//                 setTaxStatus(taxStatusData);

//                 try {
//                     const fundingResponse = await api.get(`/billing/funding-check/${businessId}`);
//                     setShowFundingWarning(fundingResponse.data.showFundingWarning);
//                     } catch (err) {
//                     console.error("❌ Funding check failed:", err);
//                     // Optional: decide to show the warning by default if the API fails
//                     setShowFundingWarning(true); 
//                     }






//                 const initialInputs = {};
//                 [...hourly, ...salaried].forEach((employee) => {
//                     initialInputs[employee.id] = {
//                         regularHours: null,
//                         overtimeHours: null,
//                         doubletimeHours: null,
//                         cashAdvance: null,
//                         bonus: null,
//                         tips: null,
//                         reimbursement: null,
//                         other: null,
//                         vacationHours: employee.type === "hourly" ? null : undefined,
//                         vacationPay: employee.type === "salaried" ? null : undefined,
//                     };
//                 });
//                 setEmployeeInputs(initialInputs);

//                 try {
//   const start = formatDate(payPeriodResponse.data.start_date);
//   const end   = formatDate(payPeriodResponse.data.end_date);

//   const { data: prefill } = await api.get('/owner/payroll-inputs', {
//     params: { business_id: businessId, start_date: start, end_date: end },
//   });

//   applyOwnerPrefill(
//     prefill || {},
//     hourly, salaried,
//     leaveResponse.data,
//     setEmployeeInputs,
//     setExcludedEmployees,
//     setLeaveRequestInputs,
//     setHourlyVacationHours,
//     setSalariedVacationHours
//   );
// } catch (e) {
//   // no prefill = fine; keep your initialInputs
//   console.log("No owner prefill for this period (ok).");
// }

//                 setError(null);
//             } catch (err) {
//                 console.error("Error fetching employees:", err);
//                 setError("Failed to fetch employees. Please try again.");
//             } finally {
//                 setLoading(false);
//             }
//         };


//         fetchData();
//     }, [businessId]);



    
//     const allEmployees = [...hourlyEmployees, ...salariedEmployees];

// const expandAll = () => {
//   const map = {};
//   allEmployees.forEach(e => { map[e.id] = true; });
//   setExpandedRows(map);
//   setAllExpanded(true);
// };

// const collapseAll = () => {
//   setExpandedRows({});
//   setAllExpanded(false);
// };

// // keep “expand all” sticky if employees list changes after load
// useEffect(() => {
//   if (!allExpanded) return;
//   const map = {};
//   allEmployees.forEach(e => { map[e.id] = true; });
//   setExpandedRows(map);
//   // eslint-disable-next-line react-hooks/exhaustive-deps
// }, [hourlyEmployees, salariedEmployees]);

    
    


//     const handleLeaveInputChange = (leaveId, employeeId, value) => {
//         setLeaveRequestInputs((prevInputs) => {
//             const newInputs = {
//                 ...prevInputs,
//                 [leaveId]: value ? parseFloat(value) : 0, // ✅ Update only this leave request input
//             };
    
//             // ✅ Calculate total vacation hours only for this employee
//             const totalVacationHours = leaveRequests
//                 .filter((leave) => leave.employee_id === employeeId) // ✅ Only sum this employee’s leave requests
//                 .reduce((sum, leave) => sum + (newInputs[leave.id] ?? 0), 0);
    
//             // ✅ Find the employee type (hourly or salaried)
//             const employee = [...hourlyEmployees, ...salariedEmployees].find(emp => emp.id === employeeId);
    
//             if (employee) {
//                 if (employee.type === "hourly") {
//                     setHourlyVacationHours((prev) => ({
//                         ...prev,
//                         [employeeId]: totalVacationHours, // ✅ Updates only this employee's vacation hours
//                     }));
//                     handleInputChange(employeeId, "vacationHours", totalVacationHours);
//                 } else {
//                     setSalariedVacationHours((prev) => ({
//                         ...prev,
//                         [employeeId]: totalVacationHours, // ✅ Updates only this employee's vacation pay
//                     }));
//                     handleInputChange(employeeId, "vacationPay", totalVacationHours);
//                 }
//             }
    
//             return newInputs; // ✅ Ensures only the changed input updates
//         });
//     };
    
    
    
    
    




//     const handleInputChange = (employeeId, field, value) => {
//         setEmployeeInputs((prev) => ({
//             ...prev,
//             [employeeId]: {
//                 ...prev[employeeId],
//                 [field]: value ? parseFloat(value) : null,
//             },
//         }));
//     };


//     const handleSubwayPayroll = () => {
//   if (!payPeriod) return;

//   navigate(`/dashboard/business/${businessId}/payroll-sync`, {
//     state: {
//       startDate: formatDate(payPeriod.start_date),
//       endDate: formatDate(payPeriod.end_date),
//     },
//   });
// };

//     const handleSubmit = async () => {
        
//         //const collectedResults = [...hourlyEmployees, ...salariedEmployees].map((employee) => {
        
//         const collectedResults = [...hourlyEmployees, ...salariedEmployees]
//             .filter((employee) => !excludedEmployees.has(employee.id)) // Exclude checked employees
//             .map((employee) => {
//             const perhourSalary = employee.salary_amt / 52 / 40 || null;

            


//             const commonFields = {
//                 id: employee.id,
//                 business_id: businessId,
//                 business_state: payPeriod.business_state,
//                 start_date: payPeriod.start_date,
//                 end_date: payPeriod.end_date,
//                 pay_date: payPeriod.pay_date,
//                 frequency: payPeriod.frequency,
//                 name: `${employee.first_name} ${employee.last_name}`,
//                 st_add: employee.e_st_add,
//                 e_suite: employee.e_suite,
//                 e_zip: employee.e_zip,
//                 filing_status: employee.filing_status,
//                 e_state: employee.e_state,
//                 e_city: employee.e_city,
//                 e_county: employee.e_county,
//                 dependents: employee.dependents,
//                 contrib_401k: employee.contrib_401k,
//                 donation: employee.donation,
//                 garnishment: employee.garnishment,
//                 additional_fed_tax: employee.additional_fed_tax,
//                 additional_state_tax: employee.additional_state_tax,
//                 work_loc: employee.work_loc,
//                 perhour_salary: perhourSalary,
//                 payment_type: employee.payment_type,
//                 employer_mandated: employee.employer_mandated,
//                 is_direct_dep: employee.is_direct_dep,
//                 account_number: employee.account_number,
//                 routing_number: employee.routing_number,
//                 ...employeeInputs[employee.id],
//             };

//             if (employee.type === "hourly") {
//                 return {
//                     ...commonFields,
//                     hourly_rate: employee.hourly_amt,
//                     vacation_hours: employeeInputs[employee.id]?.vacationHours ?? 0,
//                 };
//             } else {
//                 return {
//                     ...commonFields,
//                     salary_amt: Number(getPayPeriodSalary(employee.salary_amt)),
//                     vacation_pay: employeeInputs[employee.id]?.vacationPay !== undefined 
//                     ? employeeInputs[employee.id].vacationPay 
//                     : 0,

//                 };
//             }
//         });


//         // ✅ Collect Leave Request Updates Separately
//                 const leaveRequestUpdates = leaveRequests.map((leave) => ({
//                     leave_id: leave.id,
//                     employee_id: leave.employee_id,
//                     business_id: businessId,
//                     total_hours_paid: leave.total_hours_paid ?? 0,
//                     current_hours_paid: leaveRequestInputs[leave.id] ?? 0, // Default to 0 if not set
//                     total_hours_requested: leave.total_hours_requested,
//                     total_days_requested: leave.total_days_requested,
//                     total_days_paid: leave.total_days_paid ?? 0,
//                     leave_days_in_period: leave.leave_days_in_period,
//                     start_date: payPeriod.start_date,
//                     end_date: payPeriod.end_date,
//                     pay_date: payPeriod.pay_date,
//                 }));

    

//         try {
//             //const response = await api.post(`/payroll/calculate`, collectedResults);
//             const response = await api.post(`/payroll/calculate`, {
//                 payrollData: collectedResults,
//                 leaveRequestUpdates // ✅ Send leave requests separately
//             });
//             const { success, errors } = response.data;


//             if (errors && errors.length > 0) {  
//                 alert(
//                     `Partial success:\n\nSuccess:\n${success
//                         .map((item) => ` - ${item.name}`)
//                         .join("\n")}\n\nErrors:\n${errors.join("\n")}`
//                 );
//             } else {
//                 console.log("All payroll records processed successfully.");
//                 if (embedded && typeof onDone === "function") {
//      onDone();                // 🔔 let the parent refresh + switch to "Overview"
//    } else {
//      navigate(`/dashboard/business/${businessId}/viewpayroll`);
//    }
//             }
//         } catch (error) {
//             console.error("Error submitting payroll data:", error);
//             alert("Failed to submit payroll data. Please try again.");
//         }
//     };

//     if (loading) {
//         return <p>Loading employees...</p>;
//     }

//     if (error) {
//         return <p>{error}</p>;
//     }

//     return (
//         <div className="run-new-main">
        
            

//             {taxStatus.noIssues ? (
//                 <p></p>
                
//             ) : (
//                 <>
//                 <p className="issues-text">There are missing tax fields. Please fill tax information.</p>
//                 <button className="tax-button" onClick={() => navigate(`/dashboard/business/${businessId}/detect`)}>
//             Tax Information
//         </button>
//         </>
//             )}

//             {payPeriod && (
//                 <div className="pay-period-payroll-cont">
//                 <div className="ppl-pay">
//                     <label className="pay-period-label">Pay Period:</label>{" "}
//                     <span className="pay-period-content">
//                     {new Date(payPeriod.start_date).toLocaleDateString()} - {" "}
//                     {new Date(payPeriod.end_date).toLocaleDateString()} <br></br>
//                     </span>
//                     </div>

//                 <div className="ppl-pay">
//                     <label className="pay-period-label">Pay Date:</label>{" "}
//                     <span className="pay-period-content">
//                     {new Date(payPeriod.pay_date).toLocaleDateString()} 
//                     </span>
//                     </div>
//                 </div>
//             )}
//             <button className="run-new-submit" type="button" onClick={handleSubwayPayroll}>
//   Subway Payroll
// </button>


// <div style={{display:'flex', justifyContent:'flex-end', margin:'8px 0'}}>
//   <button
//     className="expand-all-btn"
//     onClick={allExpanded ? collapseAll : expandAll}
//   >
//     {allExpanded ? 'Collapse all' : 'Expand all'}
//   </button>
// </div>



//             <div className="run-new-employee-list">
//   {[...hourlyEmployees, ...salariedEmployees].map((employee) => {
//     const employeeLeaveRequests = leaveRequests.filter((leave) => leave.employee_id === employee.id);
//     const hasLeaveRequests = employeeLeaveRequests.length > 0;

//     return (
//       <div key={employee.id} className={`run-new-employee-block ${hasLeaveRequests ? "employee-leave-highlight" : ""}`}>

//         {/* Optional: Leave Summary & Requests */}
//         {hasLeaveRequests && (
//           <>
//             <div className="vacation-summary">
//               <div className="summary-div">Vacation Summary:</div>{" "}
//               {employee.total_vacation_hours_earned ? (
//                 <>
//                   Earned: <div>{employee.total_vacation_hours_earned ?? 0} hrs</div> |{" "}
//                   Used: <div>{employee.total_vacation_hours_used ?? 0} hrs</div> |{" "}
//                   Available: <div>{employee.available_vacation_hours ?? 0} hrs</div>
//                 </>
//               ) : "No vacation hours logged yet."}
//             </div>

//             <div className="leave-requests-section">
//               <h4>Leave Request:</h4>
//               <div className="leave-request-header">
//                 <span className="span-type">Type</span>
//                 <span className="date-span">Dates</span>
//                 <span className="days-req">Total Days</span>
//                 <span className="hours-req">Hours Req</span>
//                 <span className="hours-paid">Hours Paid</span>
//                 <span className="days-paid">Days Paid</span>
//                 <span className="hours-left">Hours Left</span>
//                 <span className="days-left">Days Left</span>
//                 <span className="period-days">Days in Period</span>
//                 <span className="this-span">Hrs This Payroll</span>
//               </div>
//               {employeeLeaveRequests.map((leave) => {
//                 const totalHoursRequested = Number(leave.total_hours_requested) || 0;
//                 const totalHoursPaid = Number(leave.total_hours_paid) || 0;
//                 const totalDaysRequested = Number(leave.total_days_requested) || 0;
//                 const totalDaysPaid = Number(leave.total_days_paid) || 0;
//                 const leaveDaysInPeriod = Number(leave.leave_days_in_period) || 0;

//                 return (
//                   <div key={leave.id} className="leave-request-row">
//                     <span className="span-type">{leave.request_type}</span>
//                     <div className="date-span">{new Date(leave.start_date).toLocaleDateString()} - {new Date(leave.end_date).toLocaleDateString()}</div>
//                     <span className="days-req">{totalDaysRequested}</span>
//                     <span className="hours-req">{totalHoursRequested}</span>
//                     <span className="hours-paid">{totalHoursPaid}</span>
//                     <span className="days-paid">{totalDaysPaid}</span>
//                     <span className="hours-left">{totalHoursRequested - totalHoursPaid}</span>
//                     <span className="days-left">{totalDaysRequested - totalDaysPaid}</span>
//                     <span className="period-days">{leaveDaysInPeriod}</span>
//                     <input
//                       type="number"
//                       placeholder="Vac. Hours"
//                       value={leaveRequestInputs[leave.id] ?? ""}
//                       onChange={(e) => handleLeaveInputChange(leave.id, leave.employee_id, e.target.value)}
//                     />
                  
//                   </div>
//                 );
//               })}
//             </div>
//           </>
//         )}

//         {/* Row 1: Basic Info */}
//         <div className="employee-info-row">
//         <div className="skip-it">
//         <label className="skip-label"> Skip </label>
//           <input
//             type="checkbox"
//             className="run-new-checkbox"
//             checked={excludedEmployees.has(employee.id)}
//             onChange={() => handleCheckboxChange(employee.id)}
//           />
//           </div>
//           <span className="run-new-name">{employee.first_name} {employee.last_name}</span>
//           <span className="run-new-type">{employee.type === "hourly" ? "Hourly" : "Salary"}</span>
//           <span className="run-new-pay">
//             {employee.type === "hourly"
//               ? `$${employee.hourly_amt} /hr`
//               : `$${getPayPeriodSalary(employee.salary_amt)} /period`}
//           </span>
//           {/* show edit only if a record exists for this employee */}
// {hasRecordByEmp[employee.id] && (
//   <button
//     className="toggle-arrow"
//     title={editing[employee.id] ? "Close edit" : "Edit"}
//     onClick={() => toggleEdit(employee.id)}
//     style={{ cursor: "pointer", background: "none", border: "none" }}
//   >
//     {editing[employee.id] ? "▲" : "✏️"}
//   </button>
// )}

//           <span className="toggle-arrow" onClick={() => toggleInputs(employee.id)}>
//             {expandedRows[employee.id] ? "▲" : "▼"}
//           </span>
//         </div>

//         {/* Row 2: Visible Inputs */}
//         <div className="employee-inputs-row">
//   {(!hasRecordByEmp[employee.id] || editing[employee.id]) ? (
//     employee.type === "hourly" ? (
//       <>
//         <input
//           type="number" placeholder="Reg. Hours"
//           value={employeeInputs[employee.id]?.regularHours ?? ""}
//           onChange={(e) => handleInputChange(employee.id, "regularHours", e.target.value)}
//         />
//         <input
//           type="number" placeholder="OT Hours"
//           value={employeeInputs[employee.id]?.overtimeHours ?? ""}
//           onChange={(e) => handleInputChange(employee.id, "overtimeHours", e.target.value)}
//         />
//         <input
//           type="number" placeholder="DT Hours"
//           value={employeeInputs[employee.id]?.doubletimeHours ?? ""}
//           onChange={(e) => handleInputChange(employee.id, "doubletimeHours", e.target.value)}
//         />
//         <input
//           type="number" placeholder="Vac. Hours"
//           value={
//             hourlyVacationHours[employee.id] ??
//             employeeInputs[employee.id]?.vacationHours ?? ""
//           }
//           onChange={(e) => {
//             const value = e.target.value;
//             setHourlyVacationHours((prev) => ({
//               ...prev,
//               [employee.id]: value ? parseFloat(value) : "",
//             }));
//             handleInputChange(employee.id, "vacationHours", value);
//           }}
//         />
//       </>
//     ) : (
//       <input
//         type="number" placeholder="Vac. Hours"
//         value={
//           salariedVacationHours[employee.id] ??
//           employeeInputs[employee.id]?.vacationPay ?? ""
//         }
//         onChange={(e) => {
//           const value = e.target.value;
//           setSalariedVacationHours((prev) => ({
//             ...prev,
//             [employee.id]: value ? parseFloat(value) : "",
//           }));
//           handleInputChange(employee.id, "vacationPay", value);
//         }}
//       />
//     )
//   ) : (
//     // read-only chips
//     employee.type === "hourly" ? (
//       <>
//         <span className={chipClass(employeeInputs[employee.id]?.regularHours)}>Regular Hours: {fmt(employeeInputs[employee.id]?.regularHours)}</span>
//         <span className={chipClass(employeeInputs[employee.id]?.overtimeHours)}>Overtime Hours: {fmt(employeeInputs[employee.id]?.overtimeHours)}</span>
//         <span className={chipClass(employeeInputs[employee.id]?.doubletimeHours)}>Doubletime Hours: {fmt(employeeInputs[employee.id]?.doubletimeHours)}</span>
//         <span className={chipClass(employeeInputs[employee.id]?.vacationHours)}>Vacation Hours: {fmt(employeeInputs[employee.id]?.vacationHours)}</span>
//       </>
//     ) : (
//       <span className={chipClass(employeeInputs[employee.id]?.vacationPay)}>Vacation Hours: {fmt(employeeInputs[employee.id]?.vacationPay)}</span>
//     )
//   )}
// </div>


//         {/* Row 3: Expanded Inputs */}
//         {expandedRows[employee.id] && (
//             <>
            
//           <div className="employee-extra-inputs">
//   {(!hasRecordByEmp[employee.id] || editing[employee.id]) ? (
//     <>
//       <input
//         type="number" placeholder="Cash Advance"
//         value={employeeInputs[employee.id]?.cashAdvance ?? ""}
//         onChange={(e) => handleInputChange(employee.id, "cashAdvance", e.target.value)}
//       />
//       <input
//         type="number" placeholder="Bonus"
//         value={employeeInputs[employee.id]?.bonus ?? ""}
//         onChange={(e) => handleInputChange(employee.id, "bonus", e.target.value)}
//       />
//       <input
//         type="number" placeholder="Tips"
//         value={employeeInputs[employee.id]?.tips ?? ""}
//         onChange={(e) => handleInputChange(employee.id, "tips", e.target.value)}
//       />
//       <input
//         type="number" placeholder="Reimbursement"
//         value={employeeInputs[employee.id]?.reimbursement ?? ""}
//         onChange={(e) => handleInputChange(employee.id, "reimbursement", e.target.value)}
//       />
      
//     </>
//   ) : (
//     <>
//       <span className={chipClass(employeeInputs[employee.id]?.cashAdvance)}>Cash Advance: {fmt(employeeInputs[employee.id]?.cashAdvance)}</span>
//       <span className={chipClass(employeeInputs[employee.id]?.bonus)}>Bonus: {fmt(employeeInputs[employee.id]?.bonus)}</span>
//       <span className={chipClass(employeeInputs[employee.id]?.tips)}>Tips: {fmt(employeeInputs[employee.id]?.tips)}</span>
//       <span className={chipClass(employeeInputs[employee.id]?.reimbursement)}>Reimbursement: {fmt(employeeInputs[employee.id]?.reimbursement)}</span>
//     </>
//   )}
// </div>
// <div className="vacation-summary-expanded">
//     <div className="summary-div">Vacation Summary:</div>{" "}
//     {employee.total_vacation_hours_earned ? (
//       <>
//         Earned: <div>{employee.total_vacation_hours_earned ?? 0} hrs</div> |{" "}
//         Used: <div>{employee.total_vacation_hours_used ?? 0} hrs</div> |{" "}
//         Available: <div>{employee.available_vacation_hours ?? 0} hrs</div>
//       </>
//     ) : (
//       "No vacation hours logged yet."
//     )}
//   </div>

// <span 
//     className="ca-balance"
//     title={`Paid Out: $${(employee.cash_advance_paid_out_total ?? 0)} | Recouped: $${(employee.cash_advance_recouped_total ?? 0)}`}
//     style={{
//       background: (employee.cash_advance_balance ?? 0) > 0 ? '#dc3545' : '#00c364',
//       color: (employee.cash_advance_balance ?? 0) > 0 ? 'white' : 'white',
//     }}
//   >
//     Cash Advance Balance: ${Number(employee.cash_advance_balance ?? 0)}
//   </span>
//           </>
//         )}
//       </div>
//     );
//   })}
// </div>



            




            

            
//             {taxStatus.noIssues && !showFundingWarning && (
//             <button className="run-new-submit" onClick={handleSubmit}>
//                 Submit
//             </button>
//             )}
//             {showFundingWarning && (
//             <div className="issues-text">
//                 No funding account is set up for this business. Please add one to continue.
//             </div>
//             )}





//             {/* <button className="run-new-submit" onClick={handleSubmit}>Submit</button> */}
            
//         </div>
//     );
// };

// export default RunNewPay;


